import { NamedView } from "@common/types/views/views";
import { SchedulesReportView } from "@common/types/views/schedulesReportView";
import { BUILT_IN_SCHEDULES_REPORT_VIEWS } from "./BuiltInSchedulesReportViews";

export function resolveBuiltInSchedulesReportView(
    viewId: string | null | undefined,
): NamedView<SchedulesReportView> | null {
    if (!viewId) {
        return null;
    }
    return (
        BUILT_IN_SCHEDULES_REPORT_VIEWS.find(
            (builtInView) => builtInView.id === viewId,
        ) ?? null
    );
}

export function buildSchedulesReportUrl(
    querySuffix: string,
    viewId: string,
): string {
    const params = new URLSearchParams(querySuffix);
    params.set("view", viewId);
    return `/accounting/schedules?${params.toString()}`;
}

export function shouldPreserveIncomingDateRangeOnDeepLink(filters: {
    startDate?: Date | string;
    endDate?: Date | string;
}): boolean {
    return filters.startDate != null && filters.endDate != null;
}
